import React, { useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { toast, ToastContainer } from 'react-toastify';
import { CloseButton, Fade } from '../components/common/Toast';
import PageMetaManager from '../components/common/PageMetaManager';
import DashboardLayout from './DashboardLayout';
import AppContext from '../context/Context';
import AuthBasicLayout from './AuthBasicLayout';
import ErrorLayout from './ErrorLayout';
import PassportPreviewPage from '../components/management/PassportPreviewPage';

const Layout = () => {
  const { sessionReady, user } = useContext(AppContext);

  if (!sessionReady) {
    return (
      <div className="psi-app-loading">
        <div className="psi-app-loading__panel">
          <Spinner color="primary" />
          <h3>Psixologik boshqaruv yuklanmoqda</h3>
          <p>Sessiya va dashboard ma`lumotlari tekshirilmoqda.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageMetaManager />
      <Switch>
        <Route path="/authentication/basic">
          {user ? <Redirect to="/" /> : <AuthBasicLayout basePath="/authentication/basic" />}
        </Route>
        <Route path="/errors" component={ErrorLayout} />
        <Route path="/psixologik-pasport/view">
          {user ? <PassportPreviewPage /> : <Redirect to="/authentication/basic/login?panel=admin" />}
        </Route>
        <Route path="/">
          {user ? <DashboardLayout /> : <Redirect to="/authentication/basic/login?panel=admin" />}
        </Route>
      </Switch>
      <ToastContainer transition={Fade} closeButton={<CloseButton />} position={toast.POSITION.BOTTOM_LEFT} />
    </>
  );
};

export default Layout;
